// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseAvatar__container-f6250b {
  --base-avatar-badge-background-color: var(--base-0);
  --base-avatar-badge-size: 16px;
  --base-avatar-badge-offset: 2px;
  flex-shrink: 0;
  position: relative;
}

@supports (mask-image: radial-gradient(circle, #000 0, #000 100%)) {
  .BaseAvatar__container-f6250b {
    --base-avatar-badge-background-color: transparent;
  }
  .BaseAvatar__has-badge-e4b1b4 > :first-child {
    --base-avatar-badge-radius: calc(var(--base-avatar-badge-size) / 2);
    --base-avatar-badge-mask-offset: calc(var(--base-avatar-badge-radius) - var(--base-avatar-badge-offset));
    mask-image: radial-gradient(circle var(--base-avatar-badge-radius) at calc(100% - var(--base-avatar-badge-mask-offset)) calc(100% - var(--base-avatar-badge-mask-offset)), transparent var(--base-avatar-badge-radius), #000 var(--base-avatar-badge-radius));
  }
}
.BaseAvatar__avatar-f80c49 {
  object-fit: cover;
  width: inherit;
  height: inherit;
  box-sizing: border-box;
  border-radius: var(--avatar-border-radius);
}

.BaseAvatar__text-content-f2e6d0 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font: inherit;
  letter-spacing: inherit;
  text-transform: capitalize;
  color: var(--addition-50);
  border-radius: var(--avatar-border-radius);
}

.BaseAvatar__round-05-ed0264 {
  width: 24px;
  height: 24px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-0-c4f628 {
  width: 32px;
  height: 32px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-5-f2e008 {
  width: 40px;
  height: 40px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-10-def698 {
  width: 48px;
  height: 48px;
  font: var(--font-title-9);
  letter-spacing: var(--font-spacing-title-9);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-20-c29020 {
  width: 72px;
  height: 72px;
  font: var(--font-title-7);
  letter-spacing: var(--font-spacing-title-7);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-25-a9de36 {
  width: 96px;
  height: 96px;
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-30-edbbfd {
  width: 104px;
  height: 104px;
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-40-bdf31b {
  width: 120px;
  height: 120px;
  font: var(--font-title-5);
  letter-spacing: var(--font-spacing-title-5);
  --avatar-border-radius: 50%;
}

.BaseAvatar__round-50-a2741c {
  width: 184px;
  height: 184px;
  font: var(--font-title-3);
  letter-spacing: var(--font-spacing-title-3);
  --avatar-border-radius: 50%;
}

.BaseAvatar__square-0-c0d08e {
  width: 24px;
  height: 24px;
  font: var(--font-caption-4);
  letter-spacing: var(--font-spacing-caption-4);
  --avatar-border-radius: 6px;
}

.BaseAvatar__square-10-dff7d0 {
  width: 40px;
  height: 40px;
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  --avatar-border-radius: 12px;
}

.BaseAvatar__square-20-ed0ac2 {
  width: 48px;
  height: 48px;
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  --avatar-border-radius: 12px;
}

.BaseAvatar__square-30-c78168 {
  width: 56px;
  height: 56px;
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  --avatar-border-radius: 16px;
}

.BaseAvatar__square-40-f51b37 {
  width: 72px;
  height: 72px;
  font: var(--font-title-7);
  letter-spacing: var(--font-spacing-title-7);
  --avatar-border-radius: 16px;
}

.BaseAvatar__square-45-b19ada {
  width: 104px;
  height: 104px;
  font: var(--font-title-4);
  letter-spacing: var(--font-spacing-title-4);
  --avatar-border-radius: 24px;
}

.BaseAvatar__square-47-bd75eb {
  width: 110px;
  height: 110px;
  font: var(--font-title-4);
  letter-spacing: var(--font-spacing-title-4);
  --avatar-border-radius: 12px;
}

.BaseAvatar__square-50-b82538 {
  width: 120px;
  height: 120px;
  font: var(--font-title-4);
  letter-spacing: var(--font-spacing-title-4);
  --avatar-border-radius: 32px;
}

.BaseAvatar__square-60-d56e3e {
  width: 160px;
  height: 160px;
  font: var(--font-title-3);
  letter-spacing: var(--font-spacing-title-3);
  --avatar-border-radius: 32px;
}

.BaseAvatar__square-70-b1a7ca {
  width: 184px;
  height: 184px;
  font: var(--font-title-3);
  letter-spacing: var(--font-spacing-title-3);
  --avatar-border-radius: 32px;
}

.BaseAvatar__additional-0-d31080 {
  width: 246px;
  height: 200px;
  font: var(--font-title-3);
  letter-spacing: var(--font-spacing-title-3);
  --avatar-border-radius: 6px;
}

.BaseAvatar__background-0-e48579 {
  background: var(--avatar-0);
}

.BaseAvatar__background-1-a378cf {
  background: var(--avatar-10);
}

.BaseAvatar__background-2-d81c12 {
  background: var(--avatar-20);
}

.BaseAvatar__background-3-f05ad3 {
  background: var(--avatar-30);
}

.BaseAvatar__background-4-b33a1d {
  background: var(--avatar-40);
}

.BaseAvatar__background-5-bcb20d {
  background: var(--avatar-50);
}

.BaseAvatar__background-6-d9f7bd {
  background: var(--avatar-60);
}

.BaseAvatar__background-7-b437e5 {
  background: var(--avatar-70);
}

.BaseAvatar__background-8-c56004 {
  background: var(--avatar-80);
}

.BaseAvatar__background-9-dc4f10 {
  background: var(--avatar-90);
}

.BaseAvatar__online-c83dde {
  width: 8px;
  height: 8px;
  background-color: var(--status-0);
  position: absolute;
  inset-inline-end: 2px;
  bottom: 2px;
  z-index: 1;
  border: 2px solid var(--base-0);
  border-radius: 50%;
}

.BaseAvatar__badge-a287df {
  display: flex;
  width: var(--base-avatar-badge-size);
  height: var(--base-avatar-badge-size);
  background-color: var(--base-avatar-badge-background-color);
  position: absolute;
  inset-inline-end: calc(0px - var(--base-avatar-badge-offset));
  bottom: calc(0px - var(--base-avatar-badge-offset));
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.BaseAvatar__badge-icon-abfcd6 {
  fill: var(--base-80);
  vertical-align: top;
}

.BaseAvatar__badge-lock-b2aeaf .BaseAvatar__badge-icon-abfcd6 {
  fill: var(--base-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/BaseAvatar/BaseAvatar.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,8BAAA;EACA,+BAAA;EAEA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE;IACE,iDAAA;EAAF;EAGA;IACE,mEAAA;IACA,wGAAA;IAEA,6PAAA;EAFF;AACF;AAKA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,0CAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,0CAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,4BAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,2CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,UAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,oCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kBAAA;EACA,6DAAA;EACA,mDAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF","sourcesContent":[".container {\n  --base-avatar-badge-background-color: var(--base-0);\n  --base-avatar-badge-size: 16px;\n  --base-avatar-badge-offset: 2px;\n\n  flex-shrink: 0;\n  position: relative;\n}\n\n@supports (mask-image: radial-gradient(circle, #000 0, #000 100%)) {\n  .container {\n    --base-avatar-badge-background-color: transparent;\n  }\n\n  .has-badge > :first-child {\n    --base-avatar-badge-radius: calc(var(--base-avatar-badge-size) / 2);\n    --base-avatar-badge-mask-offset: calc(var(--base-avatar-badge-radius) - var(--base-avatar-badge-offset));\n\n    mask-image: radial-gradient(circle var(--base-avatar-badge-radius) at calc(100% - var(--base-avatar-badge-mask-offset)) calc(100% - var(--base-avatar-badge-mask-offset)), transparent var(--base-avatar-badge-radius), #000 var(--base-avatar-badge-radius));\n  }\n}\n\n.avatar {\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n  box-sizing: border-box;\n  border-radius: var(--avatar-border-radius);\n}\n\n.text-content {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: capitalize;\n  color: var(--addition-50);\n  border-radius: var(--avatar-border-radius);\n}\n\n.round-05 {\n  width: 24px;\n  height: 24px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  --avatar-border-radius: 50%;\n}\n\n.round-0 {\n  width: 32px;\n  height: 32px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  --avatar-border-radius: 50%;\n}\n\n.round-5 {\n  width: 40px;\n  height: 40px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  --avatar-border-radius: 50%;\n}\n\n.round-10 {\n  width: 48px;\n  height: 48px;\n  font: var(--font-title-9);\n  letter-spacing: var(--font-spacing-title-9);\n  --avatar-border-radius: 50%;\n}\n\n.round-20 {\n  width: 72px;\n  height: 72px;\n  font: var(--font-title-7);\n  letter-spacing: var(--font-spacing-title-7);\n  --avatar-border-radius: 50%;\n}\n\n.round-25 {\n  width: 96px;\n  height: 96px;\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n  --avatar-border-radius: 50%;\n}\n\n.round-30 {\n  width: 104px;\n  height: 104px;\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n  --avatar-border-radius: 50%;\n}\n\n.round-40 {\n  width: 120px;\n  height: 120px;\n  font: var(--font-title-5);\n  letter-spacing: var(--font-spacing-title-5);\n  --avatar-border-radius: 50%;\n}\n\n.round-50 {\n  width: 184px;\n  height: 184px;\n  font: var(--font-title-3);\n  letter-spacing: var(--font-spacing-title-3);\n  --avatar-border-radius: 50%;\n}\n\n.square-0 {\n  width: 24px;\n  height: 24px;\n  font: var(--font-caption-4);\n  letter-spacing: var(--font-spacing-caption-4);\n  --avatar-border-radius: 6px;\n}\n\n.square-10 {\n  width: 40px;\n  height: 40px;\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  --avatar-border-radius: 12px;\n}\n\n.square-20 {\n  width: 48px;\n  height: 48px;\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  --avatar-border-radius: 12px;\n}\n\n.square-30 {\n  width: 56px;\n  height: 56px;\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  --avatar-border-radius: 16px;\n}\n\n.square-40 {\n  width: 72px;\n  height: 72px;\n  font: var(--font-title-7);\n  letter-spacing: var(--font-spacing-title-7);\n  --avatar-border-radius: 16px;\n}\n\n.square-45 {\n  width: 104px;\n  height: 104px;\n  font: var(--font-title-4);\n  letter-spacing: var(--font-spacing-title-4);\n  --avatar-border-radius: 24px;\n}\n\n.square-47 {\n  width: 110px;\n  height: 110px;\n  font: var(--font-title-4);\n  letter-spacing: var(--font-spacing-title-4);\n  --avatar-border-radius: 12px;\n}\n\n.square-50 {\n  width: 120px;\n  height: 120px;\n  font: var(--font-title-4);\n  letter-spacing: var(--font-spacing-title-4);\n  --avatar-border-radius: 32px;\n}\n\n.square-60 {\n  width: 160px;\n  height: 160px;\n  font: var(--font-title-3);\n  letter-spacing: var(--font-spacing-title-3);\n  --avatar-border-radius: 32px;\n}\n\n.square-70 {\n  width: 184px;\n  height: 184px;\n  font: var(--font-title-3);\n  letter-spacing: var(--font-spacing-title-3);\n  --avatar-border-radius: 32px;\n}\n\n.additional-0 {\n  width: 246px;\n  height: 200px;\n  font: var(--font-title-3);\n  letter-spacing: var(--font-spacing-title-3);\n  --avatar-border-radius: 6px;\n}\n\n.background-0 {\n  background: var(--avatar-0);\n}\n\n.background-1 {\n  background: var(--avatar-10);\n}\n\n.background-2 {\n  background: var(--avatar-20);\n}\n\n.background-3 {\n  background: var(--avatar-30);\n}\n\n.background-4 {\n  background: var(--avatar-40);\n}\n\n.background-5 {\n  background: var(--avatar-50);\n}\n\n.background-6 {\n  background: var(--avatar-60);\n}\n\n.background-7 {\n  background: var(--avatar-70);\n}\n\n.background-8 {\n  background: var(--avatar-80);\n}\n\n.background-9 {\n  background: var(--avatar-90);\n}\n\n.online {\n  width: 8px;\n  height: 8px;\n  background-color: var(--status-0);\n  position: absolute;\n  inset-inline-end: 2px;\n  bottom: 2px;\n  z-index: 1;\n  border: 2px solid var(--base-0);\n  border-radius: 50%;\n}\n\n.badge {\n  display: flex;\n  width: var(--base-avatar-badge-size);\n  height: var(--base-avatar-badge-size);\n  background-color: var(--base-avatar-badge-background-color);\n  position: absolute;\n  inset-inline-end: calc(0px - var(--base-avatar-badge-offset));\n  bottom: calc(0px - var(--base-avatar-badge-offset));\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.badge-icon {\n  fill: var(--base-80);\n  vertical-align: top;\n}\n\n.badge-lock .badge-icon {\n  fill: var(--base-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BaseAvatar__container-f6250b`,
	"has-badge": `BaseAvatar__has-badge-e4b1b4`,
	"hasBadge": `BaseAvatar__has-badge-e4b1b4`,
	"avatar": `BaseAvatar__avatar-f80c49`,
	"text-content": `BaseAvatar__text-content-f2e6d0`,
	"textContent": `BaseAvatar__text-content-f2e6d0`,
	"round-05": `BaseAvatar__round-05-ed0264`,
	"round05": `BaseAvatar__round-05-ed0264`,
	"round-0": `BaseAvatar__round-0-c4f628`,
	"round0": `BaseAvatar__round-0-c4f628`,
	"round-5": `BaseAvatar__round-5-f2e008`,
	"round5": `BaseAvatar__round-5-f2e008`,
	"round-10": `BaseAvatar__round-10-def698`,
	"round10": `BaseAvatar__round-10-def698`,
	"round-20": `BaseAvatar__round-20-c29020`,
	"round20": `BaseAvatar__round-20-c29020`,
	"round-25": `BaseAvatar__round-25-a9de36`,
	"round25": `BaseAvatar__round-25-a9de36`,
	"round-30": `BaseAvatar__round-30-edbbfd`,
	"round30": `BaseAvatar__round-30-edbbfd`,
	"round-40": `BaseAvatar__round-40-bdf31b`,
	"round40": `BaseAvatar__round-40-bdf31b`,
	"round-50": `BaseAvatar__round-50-a2741c`,
	"round50": `BaseAvatar__round-50-a2741c`,
	"square-0": `BaseAvatar__square-0-c0d08e`,
	"square0": `BaseAvatar__square-0-c0d08e`,
	"square-10": `BaseAvatar__square-10-dff7d0`,
	"square10": `BaseAvatar__square-10-dff7d0`,
	"square-20": `BaseAvatar__square-20-ed0ac2`,
	"square20": `BaseAvatar__square-20-ed0ac2`,
	"square-30": `BaseAvatar__square-30-c78168`,
	"square30": `BaseAvatar__square-30-c78168`,
	"square-40": `BaseAvatar__square-40-f51b37`,
	"square40": `BaseAvatar__square-40-f51b37`,
	"square-45": `BaseAvatar__square-45-b19ada`,
	"square45": `BaseAvatar__square-45-b19ada`,
	"square-47": `BaseAvatar__square-47-bd75eb`,
	"square47": `BaseAvatar__square-47-bd75eb`,
	"square-50": `BaseAvatar__square-50-b82538`,
	"square50": `BaseAvatar__square-50-b82538`,
	"square-60": `BaseAvatar__square-60-d56e3e`,
	"square60": `BaseAvatar__square-60-d56e3e`,
	"square-70": `BaseAvatar__square-70-b1a7ca`,
	"square70": `BaseAvatar__square-70-b1a7ca`,
	"additional-0": `BaseAvatar__additional-0-d31080`,
	"additional0": `BaseAvatar__additional-0-d31080`,
	"background-0": `BaseAvatar__background-0-e48579`,
	"background0": `BaseAvatar__background-0-e48579`,
	"background-1": `BaseAvatar__background-1-a378cf`,
	"background1": `BaseAvatar__background-1-a378cf`,
	"background-2": `BaseAvatar__background-2-d81c12`,
	"background2": `BaseAvatar__background-2-d81c12`,
	"background-3": `BaseAvatar__background-3-f05ad3`,
	"background3": `BaseAvatar__background-3-f05ad3`,
	"background-4": `BaseAvatar__background-4-b33a1d`,
	"background4": `BaseAvatar__background-4-b33a1d`,
	"background-5": `BaseAvatar__background-5-bcb20d`,
	"background5": `BaseAvatar__background-5-bcb20d`,
	"background-6": `BaseAvatar__background-6-d9f7bd`,
	"background6": `BaseAvatar__background-6-d9f7bd`,
	"background-7": `BaseAvatar__background-7-b437e5`,
	"background7": `BaseAvatar__background-7-b437e5`,
	"background-8": `BaseAvatar__background-8-c56004`,
	"background8": `BaseAvatar__background-8-c56004`,
	"background-9": `BaseAvatar__background-9-dc4f10`,
	"background9": `BaseAvatar__background-9-dc4f10`,
	"online": `BaseAvatar__online-c83dde`,
	"badge": `BaseAvatar__badge-a287df`,
	"badge-icon": `BaseAvatar__badge-icon-abfcd6`,
	"badgeIcon": `BaseAvatar__badge-icon-abfcd6`,
	"badge-lock": `BaseAvatar__badge-lock-b2aeaf`,
	"badgeLock": `BaseAvatar__badge-lock-b2aeaf`
};
module.exports = ___CSS_LOADER_EXPORT___;
